<!-- Header con Logo de Finsmart y Botón Cerrar -->
<div class="keynua-widget-header">
  <img src="assets/logos/finsmart.svg" alt="Finsmart Logo" class="keynua-widget-logo" />
  <lib-icon 
    class="keynua-widget-close-icon" 
    icon="close" 
    [isClickable]="true" 
    (onClick)="close()">
  </lib-icon>
</div>

<!-- Keynua Widget Container -->
<div id="keynua-widget-container" class="keynua-widget-container"></div>

